import { getOrRefreshBearerToken } from "../services/bearerToken.service";
import { API_VERSION } from "./commonConstant";
export const fetchFromWebApi = async (url, options = {}) => {
    
    try {
        const API_BASE_URL = `${process.env.REACT_APP_BASE_API_URL}${API_VERSION}`;

        // Build full url
        const fullUrl = `${API_BASE_URL}${url}`;

        console.log("Entered fetchFromWebApi [" + fullUrl + "]");

        // Get the bearer token
        const bearerToken = await getOrRefreshBearerToken();

        // Create the standard header options
        const headerOptions = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${bearerToken}`
            }
        };

        // Merge the options
        const mergedOptions = { ...headerOptions, ...options};

        // console.log(mergedOptions);

        // Call the fetch
        const response = await fetch(fullUrl, mergedOptions);

        if (response.status === 401 || response.status === 403) {
            console.error("Unauthorized access - logging out...");

            // Reset the bearer token as it is probably expired
            localStorage.setItem("Bearer-Token", null);
            
            // This is the code that causes the flickering I think
            window.location.href = window.location.origin + window.location.pathname;
            return;
        }

        return response;
    } catch (error) {
        console.error("Error during fetchFromWebApi:", error);
        if (error.name !== "AbortError") {
            console.error("Error during fetchFromWebApi:", error);
        }
        throw error;
    }
};